export const clients = [
  {
    title: "Tenacity Client",
    subtitle: "Blatant",
    description: "Honestly, it's pretty good lmao.",
    image: "https://i.ytimg.com/vi/HC7hniK5g-c/maxresdefault.jpg",
    link: "https://tenacity.dev",
  },
  {
    title: "Azura Client",
    subtitle: "Blatant",
    description:
      "A good free client; I got it with an invite code; I didn't apply for it.",
    image: "https://i.ytimg.com/vi/F7Ok7P9TlX0/maxresdefault.jpg",
    link: "https://azura.best",
  },
  {
    title: "Juul Client",
    subtitle: "Ghost/Closet",
    description: "Sometimes I use it, but I prefer Vape more.",
    image: "https://i.ytimg.com/vi/7tcibTd9Pqc/maxresdefault.jpg",
    link: "https://juul.lol",
  },
  {
    title: "Vape Client",
    subtitle: "Ghost/Closet",
    description:
      "So far, the best client; I literally play a lot with this client.",
    image: "https://i.ytimg.com/vi/JF9MU7RfA1o/maxresdefault.jpg",
    link: "https://vape.gg",
  },
];
